import React from "react";
import { useDispatch } from "react-redux";

import { deleteTaskAttempt } from "modules/admin/adminProjects/adminProjects.actions";
import { ModalFooter, ModalBody } from "../../../../../application/modal";
import { Button, BtnType, CheckBox, CheckType } from "../../../../primitives";
import styles from "./confirmDelete.module.scss";
import { useModelPopup } from "../../../../../common/hooks";

const ConfirmTaskDelete = ({ enqueueSnackbar, id, councilId }) => {
  const dispatch = useDispatch();
  const popup = useModelPopup();

  const [checkboxes, setCheckboxes] = React.useState({
    delete_from_existing_projects: true,
    only_from_uncompleted_tasks: false,
  });

  const handleDelete = () => {
    dispatch(deleteTaskAttempt({ councilId, taskId: id, enqueueSnackbar, checkboxes }));

    popup.hide();
  };

  const handleDismiss = () => {
    popup.hide();
  };

  return (
    <div>
      <ModalBody>
        <div className={styles.warningTxt}>
          You are about to remove this task. Do you want to proceed?
        </div>
        <label className="d-flex align-items-center mt-1">
          <CheckBox
            checkType={CheckType.BLUE}
            name="delete_from_existing_projects"
            onChange={(evt) => {
              setCheckboxes({
                ...checkboxes,
                delete_from_existing_projects: evt,
                only_from_uncompleted_tasks: !evt ? false : checkboxes.only_from_uncompleted_tasks
              })
            }}
            isChecked={checkboxes.delete_from_existing_projects}
          />
          <span>
            Delete from existing Projects
          </span>
        </label>
        {
          checkboxes.delete_from_existing_projects && (
            <label className="d-flex align-items-center mt-1">
              <CheckBox
                checkType={CheckType.BLUE}
                name="only_from_uncompleted_tasks"
                onChange={(evt) => {
                  setCheckboxes({
                    ...checkboxes,
                    only_from_uncompleted_tasks: evt
                  })
                }}
                isChecked={checkboxes.only_from_uncompleted_tasks}
              />
              <span>
            Delete only if Task is not completed
          </span>
            </label>
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button btn={BtnType.OUTLINE} onClick={handleDismiss}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          btn={BtnType.HIGHLIGHT}
          className={styles.button}
        >
          Delete
        </Button>
      </ModalFooter>
    </div>
  );
};

export default React.memo(ConfirmTaskDelete);
